import { createFileRoute } from '@tanstack/react-router'
import { LoginPage } from '_/features/auth/ui/pages/login-page'

export const Route = createFileRoute('/_auth/login')({
	staticData: { title: 'login' },
	validateSearch: (search: Record<string, unknown>): { redirect?: string } =>
		typeof search.redirect === 'string' ? { redirect: search.redirect } : {},
	component: LoginPage,
})
